import React, { useEffect } from 'react'
import ContactMapIcon from '../../assets/icons/ContactMapIcon'
import ContactTelIcon from '../../assets/icons/ContactTelIcon'
import ContactTimeIcon from '../../assets/icons/ContactTimeIcon'
import PhoneIcon from '../../assets/icons/PhoneIcon'
import InstagramIcon from '../../assets/icons/InstagramIcon'
import YoutubeIcon from '../../assets/icons/YoutubeIcon'
import WhatsappIcon from '../../assets/icons/WhatsappIcon'
import PageTitle from '../../components/common/PageTitle'
import ContactEmailIcon from '../../assets/icons/ContactEmailIcon'
import EmailIcon from '../../assets/icons/EmailIcon'
import TimeIcon from '../../assets/icons/TimeIcon'
import { useSelector } from 'react-redux'

function Contact() {
  const contactData = useSelector(state => state.Data.contactData)
  const contentData = useSelector(state => state.Data.contentData)
   useEffect(()=>{
        window.scrollTo(0,0)
     },[])
  return (
    <main className='min-h-[105vh] mb-[50px]'>
     <PageTitle title={contentData?.contact_title} />
      <section className='container '>
        <div className="flex items-start gap-[50px] mt-[30px] max-[1000px]:gap-[30px] max-[800px]:flex-col">
          <div className="flex flex-col p-[15px] gap-[10px] bg-gradient-to-r from-[var(--dark-green)] to-[var(--green)] p-[10px] min-w-[383px]  max-[800px]:min-w-full shadow rounded-[8px]">
            <div className=" flex flex-col gap-[15px]">
              <div className="flex items-center gap-[10px] ">
                <span className="inline-flex w-[50px] h-[50px] rounded-full justify-center items-center bg-white">
                  <PhoneIcon />
                </span>
                <div className='flex flex-col gap-[2px]'>
                  <a href={`tel:${contactData?.phone_2}`} className='text-left text-[18px] text-white font-[700] '>
                   {contactData?.phone_2}
                  </a>
                  {/* <a href='#' className='text-left text-[18px] text-white font-[700] '>
                  +44 20 4154 2542
                  </a> */}
                </div>
              </div>
              <div className="flex items-center gap-[10px] ">
                <span className="inline-flex w-[50px] h-[50px] rounded-full justify-center items-center bg-white">
                  <EmailIcon color={"var(--red)"} />
                </span>
                <div className='flex flex-col gap-[2px]'>
                  <a href={`mailto:${contactData?.email_1}`}  className='text-left text-[18px] text-white font-[700] '>
                     {contactData?.email_1}
                  </a>
                </div>
              </div>
              <div className="flex items-center gap-[10px] ">
                <span className="inline-flex w-[50px] h-[50px] rounded-full justify-center items-center bg-white">
                  <WhatsappIcon />
                </span>
                <div className='flex flex-col gap-[2px]'>
                  <a target='_blank' href={`https://wa.me/${contactData?.whatsapp_2?.replaceAll(" ","")?.replace("+","")}`} className='text-left text-[18px] text-white font-[700] '>
                    Whatsapp
                  </a>
                </div>
              </div>
              
            </div>
          </div>
           <div className=" h-[405px] flex-1 shadow  max-[800px]:w-full  contact_map" dangerouslySetInnerHTML={{__html: contactData?.address_1}}></div>
          {/* <div className=" h-[405px] flex-1 shadow  max-[800px]:w-full  ">
            <iframe className="rounded-[8px]" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3038.2865553118736!2d49.86633017662965!3d40.402502271441904!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40307de3f5d49c77%3A0x9726ebe88806c937!2zTsmZcmltYW4gTsmZcmltYW5vdiBtZXRyb3N0YW5zaXlhc8SxIMOnxLF4xLHFn8SxIDE!5e0!3m2!1sen!2saz!4v1740037303247!5m2!1sen!2saz" width="100%" height="100%"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          </div> */}
        </div>
      </section>
    </main>
  )
}

export default Contact
